import { useUpdateComment } from '../../../../../../viewer/src/Deepecho/helpers/api/reports/reports';
import React, { useEffect, useState } from 'react';
// import { APIClient } from 'platform/viewer/src/Deepecho/helpers/apiHelper';

// const api = new APIClient();
import { Input } from 'antd';
import { addDays } from 'date-fns';
import { EFW } from './centiles/EFW';
const { TextArea } = Input;

interface GestationalAgeResult {
  gestationalAgeWeeks: number | null;
  gestationalAgeDays: number | null;
  totalWeeksDecimal?: number | null;
  examinationDate?: Date | null;
  estimatedDueDate?: Date | null;
}

interface ExaminationResultsProps {
  editMode?: boolean;
  examData?: any;
  setExamData?: any;
  selectedFrame1ID?: number;
  selectedFrame2ID?: number;
  selectedFrame3ID?: number;
  selectedFrame4ID?: number;
  handleEGAChange_curr?: any;
  handleEGAChange_prev?: any;
  handleEGAChange_cent?: any;
  handleEFAChange_curr?: any;
  handleEFAChange_prev?: any;
  handleEFAChange_cent?: any;
  handleGRSChange_curr?: any;
  handleGRSChange_prev?: any;
  handleAFPChange_curr?: any;
  handleAFPChange_prev?: any;
  handleCommentsChange?: any;
  reportDetails?: any;
  setReportDetails?: any;
  keys_info?: any;
  calculatedGa?: GestationalAgeResult;
  setCalculatedGa?: any;
  calculateCentile?: any;
  Ga?: GestationalAgeResult;
  data?: any; // Add data prop to access the new structure
}

const ExaminationResults: React.FC<ExaminationResultsProps> = (props) => {
  const {
    editMode,
    examData,
    setExamData,
    selectedFrame1ID,
    selectedFrame2ID,
    selectedFrame3ID,
    selectedFrame4ID,
    handleEGAChange_curr,
    handleEGAChange_prev,
    handleEGAChange_cent,
    handleEFAChange_curr,
    handleEFAChange_prev,
    handleEFAChange_cent,
    handleGRSChange_curr,
    handleGRSChange_prev,
    handleAFPChange_curr,
    handleAFPChange_prev,
    handleCommentsChange,
    reportDetails,
    setReportDetails,
    keys_info,
    calculatedGa,
    setCalculatedGa,
    calculateCentile,
    Ga,
    data, // Add data prop
  } = props;
  const [age, setAge] = useState('');
  const [weight, setWeight] = useState('');

  const [efw, setEfw] = useState<number | null>(null);

  // Helper function to get measurement value by measurement name
  const getMeasurementValue = (measName: string): number | null => {
    if (!data?.data?.views) return null;
    
    for (const view of data.data.views) {
      const measurement = view.measurements.find((m: any) => m.meas_name === measName);
      if (measurement) {
        return parseFloat(measurement.value.toFixed(2));
      }
    }
    return null;
  };

  const handleCommentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newComment = e.target.value;
    setReportDetails({
      ...reportDetails,
      report: {
        ...reportDetails?.report,
        comment: newComment,
      },
    });
  };

  // const planeOneName = "femur"
  // const selectedPlaneOneFrameDetails = reportDetails?.report["femur"][selectedFrame1ID];

  // const planeTwoName = "abdominal"
  // const selectedPlaneTwoFrameDetails = reportDetails?.report["abdominal"][selectedFrame2ID];

  // const planeThreeName = "afpocket"
  // const selectedPlaneThreeFrameDetails = reportDetails?.report["afpocket"][selectedFrame3ID];

  // const planeFourName = "cephalic"

  // const selectedPlaneFourFrameDetails = reportDetails?.report["cephalic"][selectedFrame4ID];

  // const femurExist = Object.keys(reportDetails?.report["femur"]).length > 0
  //     ? true
  //     : false;
  // const abdoExist = Object.keys(reportDetails?.report["abdominal"]).length > 0
  //     ? true
  //     : false;
  // const afExist = Object.keys(reportDetails?.report["afpocket"]).length > 0
  //     ? true
  //     : false;
  // const cephalicExist = Object.keys(reportDetails?.report["cephalic"]).length > 0
  //     ? true
  //     : false;

  // - cephalic: HC, BPD
  // - abdomen: AC
  // - femur: FL
  // - af pocket: SDP

  // const methodChoices = [];
  // femurExist &&
  //   cephalicExist &&
  //   methodChoices.push({
  //     value: 'HC-FL',
  //     label: 'HC-FL',
  //   });
  // abdoExist &&
  //   methodChoices.push({
  //     value: 'AC',
  //     label: 'AC',
  //   });
  // cephalicExist &&
  //   methodChoices.push({
  //     value: 'BPD',
  //     label: 'BPD',
  //   });
  // afExist &&
  //   methodChoices.push({
  //     value: 'FL',
  //     label: 'FL',
  //   });

  // const selectedFramesForAgeCalc = {
  //   [planeOneName]: selectedPlaneOneFrameDetails,
  //   [planeTwoName]: selectedPlaneTwoFrameDetails,
  //   [planeThreeName]: selectedPlaneThreeFrameDetails,
  //   [planeFourName]: selectedPlaneFourFrameDetails,
  //   method: methodChoices[0] && methodChoices[0].value,
  // };

  // const [meth, setMeth] = useState(methodChoices[0] && methodChoices[0].value);

  // useEffect(() => {
  //   const calculteGA = async () => {
  //     const age = await api.post(`${url}/api/reports/get_ga`, {
  //       ...selectedFramesForAgeCalc,
  //       method: meth,
  //     });

  //     // let weeks = age / 7;
  //     // let days = age % 7;
  //     // setAge(`${Math.round(weeks)}w${Math.round(days)}d`)
  //     setAge(`${age.toFixed(2)}d`);
  //   };
  //   calculteGA();
  // }, [
  //   selectedFrame1ID,
  //   selectedFrame2ID,
  //   selectedFrame3ID,
  //   selectedFrame4ID,
  //   meth,
  // ]);

  // useEffect(() => {
  //   const calculteFW = async () => {
  //     const weight = await api.post(`${url}/api/reports/get_weight`, {
  //       ...selectedFramesForAgeCalc,
  //     });

  //     setWeight(`${weight.data} grams`);
  //   };
  //   calculteFW();
  // }, [selectedFrame1ID, selectedFrame2ID, selectedFrame3ID, selectedFrame4ID]);

  // const handleChange = (value: string) => {
  //   console.log(`selected ${value}`);
  //   setMeth(value);
  // };
  const handleSendComment = async () => {
    console.log('comment', reportDetails?.report?.comment);
  };

  function calculateGaAndEdd(
    hcMm: number | undefined = undefined,
    flMm: number | undefined = undefined,
    examDate: Date | undefined = undefined
  ): GestationalAgeResult {
    if (hcMm === undefined || isNaN(hcMm)) {
      return {
        gestationalAgeWeeks: null,
        gestationalAgeDays: null,
        totalWeeksDecimal: null,
      };
    }

    const ln = Math.log;

    let gaDays: number;
    if (flMm === undefined || isNaN(flMm)) {
      const lnHc = ln(hcMm);
      gaDays = Math.exp(
        0.0597 * lnHc ** 2 + 0.000000006409 * hcMm ** 3 + 3.3258
      );
    } else {
      const lnHc = ln(hcMm);
      gaDays = Math.exp(0.03243 * lnHc ** 2 + 0.001644 * flMm * lnHc + 3.813);
    }

    const gaWeeks = gaDays / 7;

    const gaWholeWeeks = Math.floor(gaWeeks);
    const gaRemainingDays = Math.round((gaWeeks - gaWholeWeeks) * 7);
    const daysToAdd = 280 - gaWeeks * 7;
    const edd = examDate ? addDays(examDate, daysToAdd) : undefined;

    return {
      gestationalAgeWeeks: gaWholeWeeks,
      gestationalAgeDays: gaRemainingDays,
      totalWeeksDecimal: gaWeeks,
      examinationDate: examDate,
      estimatedDueDate: edd,
    };
  }

  function calculateEFW(
    ac: number | null | undefined,
    fl: number | null | undefined,
    bpd: number | null | undefined
  ): number | null {
    if (
      ac === null ||
      ac === undefined ||
      isNaN(ac) ||
      fl === null ||
      fl === undefined ||
      isNaN(fl) ||
      bpd === null ||
      bpd === undefined ||
      isNaN(bpd)
    ) {
      return null;
    }

    const logEFW =
      1.335 - 0.0034 * ac * fl + 0.0316 * bpd + 0.0457 * ac + 0.1623 * fl;
    const efw = Math.pow(10, logEFW);
    return Math.round(efw * 100) / 100;
  }

  useEffect(() => {
    // Get measurements from the new structure
    const hcCm = getMeasurementValue('MEAS__HC');
    const flCm = getMeasurementValue('MEAS__FL');
    const acCm = getMeasurementValue('MEAS__AC');
    const bpdCm = getMeasurementValue('MEAS__BPD');

    // Convert to mm for HC calculation
    const hcMm = hcCm ? hcCm * 10 : undefined;
    const flMm = flCm ? flCm * 10 : undefined;
    
    const examDate = reportDetails?.report?.study?.study_date ? new Date(reportDetails.report.study.study_date) : undefined;

    const ga = calculateGaAndEdd(hcMm, flMm, examDate);
    setCalculatedGa(ga);

    // Calculate EFW using the measurements in cm
    const fetalWeight = calculateEFW(acCm, flCm, bpdCm);
    setEfw(fetalWeight);
  }, [data, reportDetails]);

  const buttonText = reportDetails?.report?.comment ? 'Update' : 'Add';
  return (
    <div className="w-full mb-4">
      <div className="mb-2 w-full rounded-md bg-card-color-200 text-title-page-color-100 p-1.5 font-medium text-sm">
        Examination Results
      </div>
      <div className="px-1">
        <table className="w-full table-fixed mb-3 text-xs md:text-sm">
          <colgroup>
            <col className="w-1/2" />
            <col className="w-1/4" />
            <col className="w-1/4" />
          </colgroup>
          <thead>
            <tr>
              <th className="text-left text-[#686C82] font-medium py-1.5">
                Measurement
              </th>
              <th className="text-left text-[#686C82] font-medium py-1.5">
                Current
              </th>
              <th className="text-left text-[#686C82] font-medium py-1.5">
                Centile
              </th>
            </tr>
          </thead>
          <tbody className="text-title-page-color-100">
            <tr>
              <td className="py-1.5">
                <span className="font-medium">Est. Gestational Age</span>
              </td>
              <td className="py-1.5">
                {calculatedGa && calculatedGa.gestationalAgeWeeks != null &&
                calculatedGa.gestationalAgeDays != null
                  ? calculatedGa.gestationalAgeWeeks +
                    'w ' +
                    calculatedGa.gestationalAgeDays +
                    'd'
                  : '***'}
              </td>
              <td className="py-1.5">***</td>
            </tr>
            <tr>
              <td className="py-1.5">
                <span className="font-medium">Est. Fetal Weight</span>
              </td>
              <td className="py-1.5">{efw ? efw.toFixed(2) + ' g' : '***'}</td>
              <td className="py-1.5">
                {calculateCentile && Ga ? calculateCentile(efw ? efw / 1000 : null, Ga.gestationalAgeWeeks, EFW) : '***'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExaminationResults;
